import { render } from "./TheSidebarResult.vue?vue&type=template&id=3f0b10c3&scoped=true"
import script from "./TheSidebarResult.vue?vue&type=script&lang=js"
export * from "./TheSidebarResult.vue?vue&type=script&lang=js"

import "./TheSidebarResult.vue?vue&type=style&index=0&id=3f0b10c3&scoped=true&lang=scss"

import exportComponent from "/Users/vladimirkurockin/Projects/NowMedia/wardrobe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f0b10c3"]])

export default __exports__